import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const servicesSchema = Joi.object({
  type: Joi.string().valid('services').required(),
  code: Joi.string().allow('', null).required(),
  image: mediaUrlSchema.required(),
  blur: mediaUrlSchema.required(),
  background: mediaUrlSchema.required(),
  title: Joi.string().allow('', null).required(),
  columns: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    icon: Joi.string().allow('', null),
    text: Joi.string().allow('', null),
    link: Joi.object({}).unknown(true).allow('', null),
    buttonText: Joi.string().allow('', null)
  }).unknown(true))
}).unknown(true);
export default servicesSchema;